import React from 'react';
import { addV2Prefix } from '@/pages/intelligence/utils/commonUtils';
import './index.scss';

export default function ARightClickToJump(props: any) {
  const {
    href = '',
    target = '_blank',
    children,
    /**仅右键点击时跳转, 左键点击为自定义 */
    onlyRightMouseClick = true,
    style,
    className,
  } = props;

  if (!href) {
    return <>{children}</>;
  }
  return (
    <a
      className={`dbi-table-gametitle-link ${className}`}
      href={addV2Prefix(href)}
      target={target}
      style={style}
      onClick={(e) => {
        /**仅右键点击时跳转, 直接单击不操作 */
        if (onlyRightMouseClick || !href) {
          //链接为空时不点击
          e.preventDefault();
        }
      }}
    >
      {children}
    </a>
  );
}
